import React from 'react';

import Radio from '@material-ui/core/Radio';

import { PersonalizedByTeamEngineMessage } from './personalized-by-team-engine-message';

export const PersonalizedByTeamEngineRadio = ({
  togglePersonalize,
  checked,
  disabled,
}: {
  togglePersonalize: () => void;
  checked: boolean;
  disabled?: boolean;
}) => (
  <div className="u-flex-center u-width-100">
    <Radio color="primary" onClick={togglePersonalize} checked={checked} disabled={disabled} />
    <PersonalizedByTeamEngineMessage />
  </div>
);
